import _extends from "@babel/runtime/helpers/extends";
var _this = this;
import React from 'react';
import { default as withStyles } from '../../styles';
import { borderWidthThin } from '../../styles/tokens';
import Popper from './../../Popper';
import MenuList from '@mui/material/MenuList';
import cn from 'classnames';
import PropTypes from 'prop-types';
export var styles = function styles(theme) {
  return {
    paper: {
      padding: 0,
      border: borderWidthThin + " solid " + theme.palette.grey[400]
    },
    popperPosition: {
      minWidth: '100%'
    },
    menuList: {
      padding: '0'
    }
  };
};
var DropdownPopper = function DropdownPopper(props) {
  var classes = props.classes,
    PopperProps = props.PopperProps,
    PaperProps = props.PaperProps,
    buttonRef = props.buttonRef,
    isMenuOpen = props.isMenuOpen,
    onClickHandler = props.onClickHandler;

  // Extract our custom classes so they aren't passed to MUI
  var popperPosition = classes.popperPosition,
    paper = classes.paper,
    menuList = classes.menuList;
  function handleListKeyDown(event) {
    if (event.key === 'Tab' || event.key === 'Escape') {
      onClickHandler(event);
    }
  }
  var getChildren = function getChildren() {
    var items = null;
    if (props.dropdown) {
      items = React.Children.toArray(props.dropdown).map(function (child, index) {
        if (! /*#__PURE__*/React.isValidElement(child)) {
          console.warn('Invalid element ', child);
          return null;
        }
        return /*#__PURE__*/React.cloneElement(child, {
          handleClose: handleClose.bind(_this),
          divider: index < props.dropdown.length - 1
        });
      });
    }
    return items;
  };
  var handleClose = function handleClose(event) {
    onClickHandler(event);
    buttonRef.current.focus();
  };
  return /*#__PURE__*/React.createElement(Popper, _extends({
    anchorEl: buttonRef.current,
    open: isMenuOpen,
    onClickAway: function onClickAway(event) {
      return onClickHandler(event);
    },
    className: cn(popperPosition, 'eds-dropdown-button-popper'),
    PaperProps: _extends({
      'aria-live': 'off',
      classes: {
        root: paper
      },
      elevation: 1
    }, PaperProps)
  }, PopperProps, {
    onKeyDown: handleListKeyDown,
    transition: false,
    placement: 'bottom-start',
    disablePortal: true
  }), /*#__PURE__*/React.createElement(MenuList, {
    className: menuList,
    role: "listbox",
    autoFocusItem: true,
    onKeyDown: handleListKeyDown
  }, getChildren()));
};
DropdownPopper.displayName = 'DropdownPopper';
DropdownPopper.propTypes = {
  classes: PropTypes.object,
  PopperProps: PropTypes.object,
  PaperProps: PropTypes.object,
  buttonRef: PropTypes.object,
  isMenuOpen: PropTypes.bool,
  onClickHandler: PropTypes.func,
  dropdown: PropTypes.array
};
export default withStyles(styles)(DropdownPopper);